'use client';

import {usePathname} from 'next/navigation';
import {useLocale, useTranslations} from 'next-intl';

const sectionLabels: Record<string, Record<string, string>> = {
  fr: {
    'a-propos': 'A propos',
    actualites: 'Actualites',
    programmes: 'Programmes',
    'les-aides': 'Les aides',
    'dar-ourabi': 'Dar Ourabi',
    contact: 'Contact',
    structures: 'Structures',
    projets: 'Projets',
    don: 'Don',
    auth: 'Connexion',
    'espace-donateur': 'Espace donateur',
    dashboard: 'Tableau de bord',
    audit: 'Journal d\'audit',
    admin: 'Administration',
    'mentions-legales': 'Mentions legales',
    confidentialite: 'Confidentialite',
    'plan-du-site': 'Plan du site',
  },
  ar: {
    'a-propos': 'حول',
    actualites: 'الأخبار',
    programmes: 'البرامج',
    'les-aides': 'المساعدات',
    'dar-ourabi': 'دار العربي',
    contact: 'اتصل بنا',
    structures: 'الهياكل',
    projets: 'المشاريع',
    don: 'تبرع',
    auth: 'تسجيل الدخول',
    'espace-donateur': 'فضاء المتبرع',
    dashboard: 'لوحة القيادة',
  },
  en: {
    'a-propos': 'About',
    actualites: 'News',
    programmes: 'Programs',
    'les-aides': 'Assistance',
    'dar-ourabi': 'Dar Ourabi',
    contact: 'Contact',
    structures: 'Structures',
    projets: 'Projects',
    don: 'Donate',
    auth: 'Login',
    'espace-donateur': 'Donor space',
    dashboard: 'Dashboard',
  },
};

export default function Breadcrumb() {
  const pathname = usePathname();
  const locale = useLocale();

  // Extract section from path: /fr/actualites -> actualites
  const segments = pathname.split('/').filter(Boolean);
  // segments[0] = locale, segments[1] = section
  const section = segments[1] || null;

  // Don't show breadcrumb on home page
  if (!section) return null;

  const homeLabel = locale === 'ar' ? 'الرئيسية' : locale === 'en' ? 'Home' : 'Accueil';
  const sectionLabel = sectionLabels[locale]?.[section] || sectionLabels['fr']?.[section] || section;

  return (
    <nav aria-label="Breadcrumb" className="bg-surface border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <ol className="flex items-center gap-2 text-sm text-muted">
          <li>
            <a href={`/${locale}`} className="hover:text-primary transition-colors">
              {homeLabel}
            </a>
          </li>
          <li aria-hidden="true" className="text-border">
            {locale === 'ar' ? '\\' : '/'}
          </li>
          <li className="text-foreground font-medium truncate" aria-current="page">
            {sectionLabel}
          </li>
        </ol>
      </div>
    </nav>
  );
}
